export default __webpack_public_path__ + "static/evolution-of-digital-wallet-and-mobile-payment-8d795d2775f548ba312d62f44f54d629.png";